<!--  -->
<template>
  <div class=''>
    <div class="txt">1．本《软件许可及服务协议》（以下简称《协议》）是软件服务使用人〈以下简称用户或者“您”）与中资云平台（以下简称“本公司”或者“我们”或者"“中资云”）之间关于用户下载、安装、使用中资云软件（包括但不限于移动电话、PDA版等各种无线手持终端版本的中资云软件，以下简称“软件”）；注册、使用、管理中资云账号；以及使用本公司提供的相关服务所订立的协议。本《协议》描述中资云与用户之间关于“软件”许可使用及服务相关方面的权利义务。“用户”或者“您”是指通过中资云提供的获取软件授权和账号注册的途径获得软件产品授权许可以及中资云公司相关服务的个人或组织。</div>
    <div class="txt">2.“中资云”软件由中资科技股份有限公司研发，并同息按照本《协议》的规定及其不时发布的操作规则提供基于互联网及移动网的相关服务（一下称“网络服务”）。为获得网络服务，用户应认真阅读、充分理解本《协议》中各条款，特别涉及免除或限制责任的条款，对用户的权利限制的条款，约定争议解决方式、司法管辖、法律适用的条款。请您审慎阅读并选择勾选接受或者不接受本《协议》（无民事行为能力人、限制民事行为能力人或者未满18周岁的未成年人应在法定监护人同下阅读）。除非您接受本《协议》所有条款，否则您无法注册成功或者使用本软件及其相关服务。您的注册账号获取、登录、使用等行为将视为对本《协议》的接受，井同意接受本《协议》各项条款的约束。</div>
    <div class="txt">3．中资云有权对本《协议》进行修改，修改后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。用户可下载安装本软件或登录网站查阅最新版协议条款。在中资云修改《协议》条款后，如果用户不接受修改后的条款，请立即停止使用中资云提供的软件和服务，如果用户继续使用中资云提供的软件和服务，即视为您已接受了修改后的协议。</div>
    <div class="txt">4．除本《协议》有明确规定外，本《协议》并未对利用本“软件”使用的中资云或合作单位的其他服务规定相关的服务条款。对于这些服务，一般有单独的服务条款加以规范，用户须在使用有相关服务时另行了解与确认。单独的服务条款与本《协议》有冲突的地方，以单独的服务条款为准。如用户使用该服务，视为对相关单独服务条款的接受。</div>
    <div class="txt">5．用户注册成功后，本公司将给予每个用户一个用户账号，该账号由本公司所有，用户完成申请注册后续手续后，获得该账号的使用权。账号使用权仅属于初始申请注册人，初始申请注册人不得与、借用、租用、转让或者出售该账号或者以其他方式许可非初始申请注册人使用该账号。用户承担账号、账号注册信息与密码的保管责任，并就其账号及密码项下的一切行为承担法律责任。</div>
    <div class="title">一、知识产权声明</div>
    <div class="txt">1.1中资云是“中资云”软件的知识产权权利人。中资云软件的一切著作权、版权、商标权、专利权、商业秘密等知识产权，以及相关的所有信息，包括但不限于：文字表达及其组合、音频、视频，图标、图饰、图标、色彩、界面设计、版面框架、有关数据、印刷材料或电子文档等均受中华人民共和国相关法在法规和相应的国际条约保护，除涉及第三方授权的软件或技术外，本公司享有上述知识产权。</div>
    <div class="txt">1.2未经本公司书面同意，用户不得为任何营利性或非营利性目的自行实施、利用、转让或许可任何三方实施、利用、转让上述知识产权，本公司保留追究上逃行为法律责任的权利。</div>
    <div class="title">二、授权范围</div>
    <div class="txt">2.1用户可以为非商业目的在单一台设备上安装、使用、显示、运行中资云软件。用户不得为商业运营目的安装、使用、运行中资云软件，不得对本软件或者本软件运行过程中释放到任何计算机内存中的数及本软件运行过程中客户与服务器端的交互数据，以及本软件运行所必能的系统数据，进行复制、更改、修改、增加、删除、挂接运行或创作任何衍生作品，形式包但不限于使用插件、外挂或非经本公司授权的第三方工具/服务接入本件和相关系统。</div>
    <div class="txt">2.2未事公司书面许可，用户不得将“中资云“软件安在未经本公司明示许可的其他终端设备上，包括但不于机顶盒、无线上网机、游戏机、电视机等。</div>
    <div class="txt">2.3保留权利：未经明示授权的其他一切权利仍归本公司所有，用户使用其他权利时须另外取得本公司面同意。</div>
    <div class="title">三、服务内容</div>
    <div class="txt">3.1“中资云”服务的具体内容中本公司据实际情况提供。</div>
    <div class="txt">3.2·中资云目的提供的网络服务为免费的网络服务。</div>
    <div class="txt">3.3用户理解并同意，本公司仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、其他与接入互联网或移动网有关的设备）及第三方收取的相关费用（如为入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行承担。本公司仅提供相关的网络服务，除此之外，对于任何用户之间、用户与第三方之间产生的任何争议问题〈包但不限于货损、货丢、费用、保险等问题），本公司司负责协调解决，但不承担任何责任。</div>
    <div class="title">四、服务变更、中断或终止</div>
    <div class="txt">4.1鉴于网络服务的特性，用户同意本公司有权随时变更、中断或终止部分或全部的网络服务。本公司将事先通过网站或信息推送等方式通告客户。</div>
    <div class="txt">4.2用户理解并同意，本公司需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此情况而造成网络服务在合理时间内的中断，本公司无须为此承担任何责任。本公司会就上述情事先通过网站或信息推送等的方式通告用户。</div>
    <div class="txt">4.3如发生下列任何一种情形，本公司有权随时中断或终止向用户提供《协议》项下的网络服务而无须对用户或任何第三方承担任何责任：（1）用户提供的个人或企业资料等信息不真实（2）用户违反本《协议》中规定的使用规则（3）用户发布虚假信息，包括但不限于货源信息、价格信息等（4）相关法律法规规定的其他情形。</div>
    <div class="txt">4.4如用户注册的免费网络服务的账号在任何连续365日未实际使用，则本公司有权删除该账户并停止为该用户提供相关的网络服务。在执行账号删除之前，本公司会向该用户发送通知。</div>
    <div class="txt">4.5用户注册的姓名如存在违反法律法规或国家政策要求，或侵犯任何第三方合法权益的情况，本公司有权禁止用户继续使用该账号、姓名。</div>
    <div class="title">五、使用规则</div>
    <div class="txt">5.1用户在申请使用中资云软件网绍服务时，必须向本公司提供准确、真实的个人或企业相关资料，且需要通过人工认证方能开始使用件。如个人或企业资料任何变动，必须及时更新。更新后，本公司有权暂停该用户的使用权，同时需要人工再次认证方能继续使用软件。个人资料变动后，用户没有及时进行息更新或者不配合本公司进行信息更新或人工认证，由此造成的损失（包括但不限于软件无法进行正常使用、与第三者发生的纠纷等），应由用户自行承担。</div>
    <div class="txt">5.2用户不应将其账号、密码转让出借予他人使用。如用户发现其账号遭他人非法使用，应立即通知本公司。因黑客行为，病毒等原因或因用户的保管疏忽导致账号、密码遭他人非法使用，本公司不承担任何责任。</div>
    <div class="txt">5.3用户同意，本公司有权在提供网络服务过程中通过中资云软件其手机推送信或者其他方式。</div>
    <div class="txt">5.4用户同意，本公司有权在提供网络服务过中以各种方式投放本公司的其他任何类型的商业产品信息。</div>
    <div class="txt">5.5用户在使用中资云服务过程中，必须遵循以下原则：（1）遵守中国的有关的法律和法规（2）遵守所以与网络服务有关的网络协议、规定和程序（3）不得为任何非法目的而使用网络服务系统（4）不得以任何形式使用中资云服务侵犯本公司的商业利益，包括并不限于发布非经本公司许可的商业广告（5）不得利用中资云网络服务系統进行任何可能对互联网或移动网正常运转造成不利影响的行为（6）不得利用本产品提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的．恐吓性的、庸俗淫秽的或其他任何非法的信息材料（7）不得侵权其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益（8）不得利用系统进行任何不利于本公司的行为（包括但不限于窃取．外泄服务系統内的信息等）（9）相关法律法规规定的其他形。</div>
    <div class="txt">5.6本公司针对某些特定的中资云网络服务的使用通过各种形式（包括但不限于网页公告、短信提醒等）作出的任何声明、通知、警示等内容视为本《协议》的一部分，用户如使用该网络服务，视为用户同意该等声明、通知、警示的内容并受其约束。</div>
    <div class="txt">5.7您在此不可撤销的同意并授权，通过中资云所完成的每一单运单均会形成一份电子合约来约定您和中资云的商业行为。您需同意且遵守合约之规定，否则即便您订单形成事实交易也不作为约束我公司之条款。</div>
    <div class="title">六、“中资云”管理规定</div>
    <div class="txt">6.1用户注册“中资云”账号，注册内容、各种信息、用户本人应当为信息的真实性负责。同时用户应当使用真实身份信息，不得以虚假、冒用的居民信息进行注册。</div>
    <div class="txt">6.2用户在使用中资云时，应保证信息真实，诚信为本，禁止爽约、恶意下单等行为，一经发现，本公司有权停止用户账号，并可视情节严重性，追究其法律责任。</div>
    <div class="txt">6.3中资云将建立键全用户信皂安全管理制度、落实技术安全防控措施。本公司将会采取合的措施，对用户使用中资云网络服务过程中涉及的用户隐私内容加以保护。</div>
    <div class="title">七、隐私保护</div>
    <div class="txt">7.1保护用户隐私是本公司的一项基本政策，本公司保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在中资云的非公开内容，但下列情除外：（1）事先获得用户的明确授权（2）根据有关的法律法规要求（3）照相关政府主管部分的要求（4）为维护社会公众的利益（5）为维护本公司的合法权益。</div>
    <div class="txt">7.2中资云可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本公司同等的保护用户隐私的责任，则本公司有权将用户的注册资等提供给第三方。</div>
    <div class="txt">7.3在不透露单个用户隐私资料的前提下，公司有权对整个用户数据库进行分析并对用户数据进行商业上的利用。</div>
    <div class="title">八、免责声明</div>
    <div class="txt">8.1用户理解并其同意，使用本公司网络服务所存在的风险将完全由其自己承妲，因其使用本公司网络服务而产生的一切后果也由自己承担，本公司对用户不承担任何责任。</div>
    <div class="txt">8.2本公司对网络服务不做任何类型的担保，不论是明示的、默示的或法令的保证和条件，包括但不限于服务的及时性、安全性、准确性，对在任何情况下因使用或不能使用本网络服务所产生的直接、间隔、偶然、特殊及后续的损害及风险，本公司不承担任何责任。</div>
    <div class="txt">8.3对于不可抗力，计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何网络、枝术、通信线路等原因造成的服务中断或不能满足用户要求的风险，由用户自行承担，本公司不承担任何责任。</div>
    <div class="txt">8.4用户理解并同意，对于本公司向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，本公司无须承担任何责任：（1）本公司向用户免费提供的各项网络服务（2）本公司向用户赠送的任何产品、积分或者服务。</div>
    <div class="txt">8.5用户理解并同意中资云提供的功能受制于我国的交通法律法规和管理条例，即当本产品的功能和条例发生冲突时，应以各地的交法规和管理条例为最高准则。任何通过中资云服务直接或间接违反当地交通法律法和管理条例的行为，该后果应由用户承担。如有举证需要，本公司可以向有关部门提供相关数据作为证据。</div>
    <div class="txt">8.6用户理解安全驾驶的重要性，切保证在任何可能引起安全隐患的情况下均不得使用中资云·，并同意一切因使用中资云服务而导致的安全隐患和因此产生的纠和交通事故，本公司概不负责赔偿，如有举证需要，本公司可以向行关部门提供相关数据作为证据。</div>
    <div class="title">九、违约责任</div>
    <div class="txt">9.1如因本公司违反有关法律、法规或本《协议》的任何条款而给用户造成的损失，本公司同意承担由此成的损害赔偿责任。</div>
    <div class="txt">9.2用户同意保障和维护本公司及其其他用户的利益，如因用户违反有关法律、法规或本《协议》项下的任何条款而给本公司或任何第三人造成损失，用户同意独立承担相关的法律责任。</div>
    <div class="title">十、协议修改</div>
    <div class="txt">10.1本公司有权随时修改本《协议》的任何条款，一旦本《协议》的内容发生变动，本公司将会直接在本公司网站或者APP上公布修改之后的协议内容，该公布行为视为本公司已经通知用户修改内容。同时本公司也可通过其他适当方式向用户提示修改内容。</div>
    <div class="txt">10.2如果不同意本公司对本《协议》相关条款所做的修改，用户应当停止使用网络服务。如用户继续使用网络服务，则视为用户受本公司对本《协议》相关条款所做的修改并同意受其约束。</div>
    <div class="title">十一、通知送达</div>
    <div class="txt">11.1本《协议》项下本公司对于用户所有的通知均可通过网页公告、手机短信等方式进行，该等通知于发送之日视为已送达收件人。</div>
    <div class="txt">11.2用户对于本公司的通知应当通过本公司对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。该等通知以本公司实际收到日为送达日。</div>
    <div class="title">十二、法律管辖</div>
    <div class="txt">12.1本《协议》的订立、成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区的法律并受中国有管辖权的法院管理。</div>
    <div class="txt">12.2与本《协议》有关的或由本《协议》引起的任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向本公司所在地的人民法院提诉讼。</div>
    <div class="title">十三、其他规定</div>
    <div class="txt">13.1本《协议》构成双方对本《协议》之约定事项及其他有关事宜的完整协议，除本《协议》定的之外，未赋予本《协议》各方其他权利。</div>
    <div class="txt">13.2如本《协议》中的任何条款无论因何种原因完全或部分无效或不具有执行力，本《协议》的其余条款仍应有效并且有约束力。</div>
    <div class="txt">13.3本《协议》的所有标题仅仅是为了醒目及阅读方便，本身并无实际涵义，不能作为本《协议》涵义解释之依据。</div>

  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  }
}
</script>

<style lang="less" scoped>
div {
  text-indent: 2em;
  margin-bottom: 12px;
}

.title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #252a37;
  letter-spacing: 0.25px;
  text-align: justify;
  font-weight: bold;
}

.txt {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #252a37;
  letter-spacing: 0.25px;
  text-align: justify;
  line-height: 22px;
}
</style>
